import React from "react";
import Classes from "classnames";

export function SelectorIconComponent(icon: string) {

    return <div className={Classes(icon, "w-15 h-15 m-r-5")}></div>
}
